export type SalesContact = {
  name: string;
  phone: string;
  role: string;
  avatar: string;
  status: string;
};

export const salesContacts: SalesContact[] = [
  {
    name: "Valentina Febriyanti",
    phone: "+6282125886584",
    role: "Sales Kolabo",
    avatar: "/assets/optimized/valentina-ac95c93664.webp",
    status: "Online",
  },
  {
    name: "Safnah Putri",
    phone: "+6281385240669",
    role: "Sales Kolabo",
    avatar: "/assets/optimized/safnah-dd9f50ee2a.webp",
    status: "Online",
  },
];
